import { Injectable } from '@angular/core';
import { ParseService } from '../parse/parse.service';
import { StorageConfiguration } from '../storage-setting/storage-configuration';

@Injectable({
  providedIn: 'root'
})

export class DateServiceService {
  tenantId: any;

  constructor(
    private parseService: ParseService,
    private storageConfiguration: StorageConfiguration
  ) {
    this.tenantId = this.storageConfiguration.sessionGetItem(this.storageConfiguration.tenantId);
  }

  addGMTOffset(somedate) {
    let date = somedate._d;
    if (!date) {
      date = somedate;
    }
    var datewithoffset = new Date(date.getTime() - date.getTimezoneOffset() * 60000);
    return datewithoffset;
  }

  startEndDateByMonth(day): any {
    let startdate = this.prevMnth(new Date(day));
    startdate.setHours(23, 59, 59, 999);
    let enddate: any;
    if (day.getMonth() !== new Date().getMonth()) {
      enddate = this.nextMnth(day);
      enddate.setHours(0, 0, 0, 0);
    } else {
      enddate = new Date();
      enddate.setHours(0, 0, 0, 0);
    }
    return [startdate, enddate];
  }

  getLastWeekFilter(day): any {
    let startWeek = this.prevWeek(new Date(day));
    startWeek.setHours(0, 0, 0, 0);
    var days = 7;
    var date = new Date();
    var last = new Date(date.setHours(0, 0, 0, 0) - (days * 24 * 60 * 60 * 1000));
    return [last, startWeek];
  }

  getLastTwoWeeks(day): any {
    let startWeek = this.prevWeek(new Date(day));
    startWeek.setHours(0, 0, 0, 0);
    var days = 14;
    var date = new Date();
    var last = new Date(date.setHours(0, 0, 0, 0) - (days * 24 * 60 * 60 * 1000));
    return [last, startWeek];
  }

  getFullRecord(start, end): any {
    return [start, end];
  }

  getLastThirtyDays(date): any {
    const today = date;
    const priorDate = new Date(new Date().setDate(today.getDate() - 30));
    today.setHours(23, 59, 59, 999);
    priorDate.setHours(0, 0, 0, 0);
    // console.log(today);
    // console.log(priorDate);
    return [priorDate, today];

  }

  nextMnth(d): any {
    let day = new Date(d);
    return new Date(day.getFullYear(), day.getMonth() + 1, 1);
  }

  prevMnth(d): any {
    let day = new Date(d);
    return new Date(day.getFullYear(), day.getMonth(), 0);
  }

  prevWeek(d): any {
    let day = new Date(d);
    return new Date(day.getFullYear(), day.getMonth(), day.getUTCDate(), 0);

  }

  startEndDateByDate(day): any {
    let startdate = this.prevDay(new Date(day));
    startdate.setHours(23, 59, 59, 999);
    let enddate = this.nextDay(day);
    enddate.setHours(0, 0, 0, 0);
    return [startdate, enddate];
  }

  nextDay(d) {
    let day = new Date(d);
    return new Date(day.setDate(day.getDate() + 1));
  }

  prevDay(d) {
    let day = new Date(d);
    return new Date(day.setDate(day.getDate() - 1));
  }

  /**
   * 
   * @param data ('01:00')
   * @returns output 3600
   */

  convertStringHrsToSeconds(data): any {
    const dateString = data.split(':');
    const hours = dateString[0] * 3600;
    const minutes = dateString[1] * 60;
    const seconds = Math.abs(hours.valueOf() + minutes.valueOf());
    return seconds;
  }

  /**
   * 
   * @param d (3600) in seconds
   * @returns ('01:00') return string format
   */

  convertSecondsToHmString(d): any {
    d = Number(d);
    const h = Math.floor(d / 3600);
    const m = Math.floor(d % 3600 / 60);
    const s = Math.floor(d % 3600 % 60);

    const hDisplay = (h <= 9 ? '0' : '') + h;
    const mDisplay = (m <= 9 ? '0' : '') + m;

    return hDisplay + ':' + mDisplay;
  }

  secondsToHms(d) {
    d = Number(d);
    var h = Math.floor(d / 3600);
    var m = Math.floor(d % 3600 / 60);
    var s = Math.floor(d % 3600 % 60);

    var hDisplay = (h <= 9 ? '0' : '') + h;
    var mDisplay = (m <= 9 ? '0' : '') + m;
    var sDisplay = (s <= 9 ? '0' : '') + s;
    return hDisplay + ':' + mDisplay + ':' + sDisplay;
  }

  async getProjectMemberCount(projectId) {
    let queryInstance = this.parseService.instance.Object.extend('ProjectMembers');
    let query = new this.parseService.instance.Query(queryInstance);
    query.equalTo('project', { __type: 'Pointer', className: 'Project', objectId: projectId });
    query.equalTo('status', 'Assigned');
    query.equalTo('tenantId', this.tenantId);
    let projectMembersDetails = await query.find();
    if (projectMembersDetails.length > 0) {

      var billableCount: any = 0;
      var nonBillableCount: any = 0;

      for (let data of projectMembersDetails) {
        let isBillable = data.get('isBillable') ? data.get('isBillable') : false;
        if (isBillable) { billableCount = billableCount + 1; }
        else { nonBillableCount = nonBillableCount + 1; }
      }

      billableCount = billableCount;
      nonBillableCount = nonBillableCount;
      var totalBillableCount: any = Number(billableCount) + Number(nonBillableCount);

      let Project = this.parseService.instance.Object.extend('Project');
      let project = new this.parseService.instance.Query(Project);
      project.equalTo('objectId', projectId);
      let result = await project.find();
      let projectInfo = result[0];
      projectInfo.set('billableCount', String(billableCount));
      projectInfo.set('nonBillableCount', String(nonBillableCount));
      projectInfo.set('totalBillableCount', String(totalBillableCount));
      let projectDetails = await projectInfo.save();
    }
  }


}
